import React from "react";
import Switch from "@material-ui/core/Switch";
import { compose } from "recompose";
import { translate } from "react-admin";

/**
 * トグルボタンで入力するInputコンポーネント。
 * react-adminのEdit画面ではBooleanInputを用いること
 * @component
 */
const SwitchInput = ({ label, toggle, onChange, translate, disabled }) => {
  return (
    <div style={{ display: "flex", verticalAlign: "bottom" }}>
      <Switch
        checked={toggle}
        onChange={onChange}
        color="primary"
        inputProps={{ "aria-label": "toggle button" }}
        disabled={disabled}
      />
      <div style={{ paddingTop: 13 }}>{translate(label)}</div>
    </div>
  );
};

const enhance = compose(translate);
export default enhance(SwitchInput);
